/* global document, Office, window */

import { login, AuthError } from "../services/auth.service";
import { isAuthenticated } from "../services/storage.service";

Office.onReady((info) => {
  // Toujours initialiser, même si on n'est pas dans Word (pour le test dans le navigateur)
  initializeAuth();
});

function initializeAuth(): void {
  // Check if already authenticated
  if (isAuthenticated()) {
    console.log("✅ User authenticated, redirecting to Dashboard...");
    window.location.href = "dashboard.html";
    return;
  }

  // Show Auth UI (it is visible by default in HTML but we can ensure it)
  const authSection = document.getElementById("auth-section");
  if (authSection) {
      authSection.classList.remove("hidden");
  }

  // Login Handler
  const loginBtn = document.getElementById("loginBtn");
  if (loginBtn) {
      loginBtn.onclick = handleLogin;
  }
  
  // Enter key support
  const passwordInput = document.getElementById("password");
  if (passwordInput) {
      passwordInput.addEventListener("keypress", (e) => {
          if (e.key === "Enter") handleLogin();
      });
  }
}

async function handleLogin(): Promise<void> {
    const usernameInput = document.getElementById("username") as HTMLInputElement;
    const passwordInput = document.getElementById("password") as HTMLInputElement;
    const errorDiv = document.getElementById("auth-error");

    if (errorDiv) {
        errorDiv.classList.add("hidden");
        errorDiv.textContent = "";
    }

    const username = usernameInput?.value;
    const password = passwordInput?.value;

    if (!username || !password) {
        if (errorDiv) {
            errorDiv.textContent = "Veuillez remplir tous les champs.";
            errorDiv.classList.remove("hidden");
        }
        return;
    }

    try {
        await login({ username, password });
        console.log("✅ Login success, redirecting...");
        window.location.href = "dashboard.html";
    } catch (error) {
        console.error("Login Error:", error);
        if (errorDiv) {
            errorDiv.textContent = (error as AuthError).message || "Échec de la connexion.";
            errorDiv.classList.remove("hidden");
        }
    }
}
